'use strict';

export default class MemTransactionViewCtrl {
  constructor($stateParams, $state, LoaderSvc, MemTxnSvc, GroupAuthSvc) {
    var that = this;
    this.ctxId = $stateParams.ctxId; // current group
    this.personId = $stateParams.perId;
    this.mtId = $stateParams.mtId;

    // authorization
    GroupAuthSvc.validatePermission(this.ctxId, 'memberTransaction', 'R');

    if(!this.mtId) {
      return $state.go('group.memberView.memberTransaction.list');
    }
    //load memberTransaction
    function loadMemberTransaction() {
      LoaderSvc.start();
      var reqParams = {
        groupId: that.ctxId,
        personId: that.personId,
        id: that.mtId
      };
      MemTxnSvc.get(reqParams).$promise
        .then(function(memberTransaction) {
        // get linked financial trnsaction
          var ft = memberTransaction.finTxn;
          var finTxn;
          if(ft) {
            finTxn = ft;
          }
          // set status
          if(!finTxn) {
            memberTransaction.status = 'Unpaid';
          } else if(finTxn.acceptedAt) {
            memberTransaction.status = 'Paid';
          } else if(finTxn.submittedAt) {
            memberTransaction.status = 'Pending - Payment Submitted';
          }
          that.memberTransaction = memberTransaction;
          LoaderSvc.stop();
        }).catch(function() {
          LoaderSvc.stopError('Error loading Member Transaction');
        });
    }
    loadMemberTransaction();
  }
}

MemTransactionViewCtrl.$inject = [
  '$stateParams',
  '$state',
  'LoaderSvc',
  'MemTxnSvc',
  'GroupAuthSvc'
];
